import { z } from "zod";

import { FormField } from "../../../FormEngine/types";
import { multiSelectResponseSchema } from "../../common/schemaHelper";

/**
 * Weight History form schema
 *
 * This schema defines the fields for the Weight History form
 * using the FormEngine component.
 */
export const weightHistorySchema: FormField[] = [
  {
    type: "select",
    name: "weightGainStart",
    title: "Weight Gain Start",
    description: "When did your weight gain start?",
    label: "Select age group",
    fieldProps: {
      options: ["Childhood", "Puberty", "Teens", "Adulthood"].map((opt) => ({
        label: opt,
        value: opt,
      })),
    },
  },
  {
    type: "multi-select",
    name: "weightGainInfluence",
    title: "Weight Gain Influence",
    description: "Have any of the following influenced your weight gain?",
    options: ["Pregnancy", "Injury", "Life events", "Traumatic events", "Medications"].map((opt) => ({
      label: opt,
      value: opt,
    })),
    fieldProps: {
      includeOtherOption: true,
      includeNoneOption: true,
    },
    rule: z.array(z.string()).min(1, { message: "Please select at least one option" }),
  },
  {
    type: "select",
    name: "weightTrend",
    title: "Weight Trends",
    description: "Which of the following best describes your weight trends?",
    label: "Select weight trend",
    fieldProps: {
      options: [
        "Gradual increase",
        "Gains with series of plateaus",
        "Yo-yo",
        "I have lost and gained more than 50 pounds",
        "Other",
      ].map((opt) => ({ label: opt, value: opt })),
    },
  },
  {
    type: "group-input",
    title: "Goal Weight (Optional)",
    name: "goalWeight",
    description: "What do you feel is a healthy and realistic goal weight for you?",
    fieldProps: {
      direction: "row",
      spacing: 1,
    },
    group: [
      {
        type: "input",
        name: "goalWeight",
        label: "Enter Goal Weight",
      },
      {
        type: "toggle-buttons",
        name: "goalWeightUnit",
        options: ["lbs", "kg"].map((opt) => ({ label: opt, value: opt })),
        fieldProps: {
          sx: { mt: "0 !important" },
        },
      },
    ],
  },
  {
    type: "multi-select-response",
    name: "weightGoalDescription",
    title: "Weight Goal Description",
    description: "Describe your weight goals, if you have any.",
    options: [
      "Feel better",
      "Be more active",
      "Prevent health problems",
      "Feel more confident",
      "Other",
    ].map((opt) => ({ label: opt, value: opt })),
    schema: [
      {
        type: "input",
        name: "description",
        label: "Description",
      },
    ],
    fieldProps: {
      includeNoneOption: true,
    },
    rule: z
      .array(multiSelectResponseSchema)
      .min(1, { message: "Please select at least one option" }),
  },
];

export default weightHistorySchema;
